import React from "react";

const privacyHTML = `<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Privacy Policy — ELDE</title>
    <link
      href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600&display=swap"
      rel="stylesheet"
    />
    <style>
      *,
      *::before,
      *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      :root {
        --dark: #0f0f1a;
        --navy: #1a1a2e;
        --blue: #4f7ffa;
        --cyan: #00bcd4;
        --text: #1a1a2e;
        --muted: #64748b;
        --border: #e2e8f0;
        --bg: #f8fafc;
      }

      body {
        font-family: "DM Sans", sans-serif;
        background: var(--bg);
        color: var(--text);
        line-height: 1.7;
      }

      /* Header */
      header {
        background: var(--navy);
        padding: 20px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .logo {
        display: inline-flex;
        align-items: center;
        border: 2px solid var(--cyan);
        border-radius: 6px;
        padding: 3px 10px;
        text-decoration: none;
      }
      .logo-el {
        font-family: "DM Serif Display", serif;
        font-size: 20px;
        color: #fff;
        letter-spacing: 2px;
      }
      .logo-de {
        font-family: "DM Serif Display", serif;
        font-size: 20px;
        color: var(--cyan);
        letter-spacing: 2px;
      }

      /* Hero */
      .hero {
        background: linear-gradient(135deg, var(--navy) 0%, #1e2a4a 100%);
        padding: 72px 24px 56px;
        text-align: center;
        position: relative;
        overflow: hidden;
      }
      .hero::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image:
          linear-gradient(rgba(79, 127, 250, 0.06) 1px, transparent 1px),
          linear-gradient(90deg, rgba(79, 127, 250, 0.06) 1px, transparent 1px);
        background-size: 40px 40px;
      }
      .hero-badge {
        display: inline-block;
        background: rgba(79, 127, 250, 0.15);
        border: 1px solid rgba(79, 127, 250, 0.3);
        color: #93b4ff;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        padding: 5px 14px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;
      }
      .hero h1 {
        font-family: "DM Serif Display", serif;
        font-size: clamp(36px, 6vw, 56px);
        color: #fff;
        line-height: 1.15;
        margin-bottom: 16px;
        position: relative;
      }
      .hero-sub {
        color: #8899bb;
        font-size: 16px;
        position: relative;
      }

      /* Layout */
      .container {
        max-width: 760px;
        margin: 0 auto;
        padding: 64px 24px;
      }

      /* TOC */
      .toc {
        background: #fff;
        border: 1px solid var(--border);
        border-radius: 16px;
        padding: 28px 32px;
        margin-bottom: 48px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
      }
      .toc-title {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: var(--muted);
        margin-bottom: 14px;
      }
      .toc ol {
        padding-left: 18px;
      }
      .toc li {
        margin-bottom: 6px;
      }
      .toc a {
        color: var(--blue);
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
      }
      .toc a:hover {
        text-decoration: underline;
      }

      /* Sections */
      section {
        margin-bottom: 48px;
      }
      .section-num {
        display: inline-block;
        background: var(--blue);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        width: 24px;
        height: 24px;
        border-radius: 6px;
        text-align: center;
        line-height: 24px;
        margin-right: 10px;
        vertical-align: middle;
      }
      h2 {
        font-family: "DM Serif Display", serif;
        font-size: 24px;
        color: var(--text);
        margin-bottom: 16px;
        padding-top: 8px;
        border-top: 2px solid var(--border);
      }
      h3 {
        font-size: 15px;
        font-weight: 600;
        color: var(--text);
        margin: 20px 0 8px;
      }
      p {
        font-size: 15px;
        color: #374151;
        margin-bottom: 14px;
      }
      ul {
        padding-left: 20px;
        margin-bottom: 14px;
      }
      li {
        font-size: 15px;
        color: #374151;
        margin-bottom: 6px;
      }

      /* Highlight boxes */
      .highlight {
        background: linear-gradient(135deg, #eef2ff, #e0f2fe);
        border: 1px solid #c7d2fe;
        border-radius: 12px;
        padding: 18px 20px;
        margin: 20px 0;
        font-size: 14px;
        color: #1e3a5f;
      }
      .highlight strong {
        color: var(--blue);
      }

      /* Contact card */
      .contact-card {
        background: var(--navy);
        border-radius: 16px;
        padding: 28px 32px;
        color: #fff;
        margin-top: 48px;
      }
      .contact-card h2 {
        color: #fff;
        border-top-color: rgba(255, 255, 255, 0.1);
        font-family: "DM Serif Display", serif;
      }
      .contact-card p {
        color: #8899bb;
      }
      .contact-card a {
        color: var(--cyan);
        text-decoration: none;
        font-weight: 600;
      }

      /* Footer */
      footer {
        text-align: center;
        padding: 32px 24px;
        border-top: 1px solid var(--border);
        font-size: 13px;
        color: var(--muted);
      }

      @media (max-width: 600px) {
        .container {
          padding: 40px 16px;
        }
        .toc {
          padding: 20px;
        }
      }
    </style>
  </head>
  <body>
    <header>
      <a href="javascript:history.back()" class="logo">
        <span class="logo-el">EL</span><span class="logo-de">DE</span>
      </a>
      <span style="color: #8899bb; font-size: 13px">Privacy Policy</span>
    </header>

    <div class="hero">
      <div class="hero-badge">Legal</div>
      <h1>Privacy Policy</h1>
      <p class="hero-sub">Last updated: LAST_UPDATED_DATE</p>
    </div>

    <div class="container">
      <div class="highlight">
        <strong>The short version:</strong> ELDE collects only what's needed to
        run the app. We don't sell your data, show you ads, or share your
        financial information with third parties. Your debt data belongs to you.
      </div>

      <div class="toc">
        <div class="toc-title">Table of Contents</div>
        <ol>
          <li><a href="#information">Information We Collect</a></li>
          <li><a href="#use">How We Use Your Information</a></li>
          <li><a href="#storage">Data Storage & Security</a></li>
          <li><a href="#sharing">Information Sharing</a></li>
          <li><a href="#ai">AI Features (Ellie Advisor)</a></li>
          <li><a href="#account-deletion">Data Retention &amp; Account Deletion</a></li>
          <li><a href="#rights">Your Rights</a></li>
          <li><a href="#children">Children's Privacy</a></li>
          <li><a href="#changes">Changes to This Policy</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ol>
      </div>

      <section id="information">
        <h2><span class="section-num">1</span> Information We Collect</h2>

        <h3>Account Information</h3>
        <p>When you create an ELDE account, we collect:</p>
        <ul>
          <li>Email address</li>
          <li>Password (stored securely, never in plain text)</li>
          <li>Name (if provided via Google or Apple Sign In)</li>
        </ul>

        <h3>Financial Data You Enter</h3>
        <p>ELDE stores the debt information you manually enter, including:</p>
        <ul>
          <li>Account names, types, and balances</li>
          <li>Interest rates and minimum payments</li>
          <li>Payment history and dates</li>
          <li>Payoff strategy preferences</li>
        </ul>
        <p>
          We do <strong>not</strong> connect to your bank accounts, access your
          real financial accounts, or collect any data you haven't explicitly
          entered.
        </p>

        <h3>Usage &amp; Analytics Data</h3>
        <p>
          We use <strong>PostHog</strong>, a product analytics service, to
          understand how people use ELDE so we can improve it. This includes:
        </p>
        <ul>
          <li>Which screens you view and which features you use</li>
          <li>App version, device type, and general technical information</li>
          <li>
            Pseudonymous session activity, tied to a random account identifier
            rather than your name or email
          </li>
        </ul>
        <p>
          Your financial information is deliberately kept out of analytics:
          balances, payment amounts, interest rates, and other monetary values
          are stripped from analytics events, and all on-screen text and form
          inputs are masked in any session replay — so your actual debt figures
          are never captured. We never sell analytics data or use it for
          advertising. PostHog processes this information on our behalf under its
          <a href="https://posthog.com/privacy" style="color: var(--blue)">privacy policy</a>.
        </p>
      </section>

      <section id="use">
        <h2><span class="section-num">2</span> How We Use Your Information</h2>
        <p>We use your information solely to:</p>
        <ul>
          <li>Provide and operate the ELDE app</li>
          <li>Sync your data across your devices</li>
          <li>Send account-related emails (confirmation, password reset)</li>
          <li>Power the Ellie AI advisor feature</li>
          <li>
            Improve the app based on aggregated, anonymized usage patterns
          </li>
        </ul>
        <p>
          We will never use your financial data for advertising, profiling, or
          sale to third parties.
        </p>
      </section>

      <section id="storage">
        <h2><span class="section-num">3</span> Data Storage & Security</h2>
        <p>
          Your data is stored securely using <strong>Supabase</strong>, a hosted
          database platform with industry-standard security practices including:
        </p>
        <ul>
          <li>Encryption at rest and in transit (TLS)</li>
          <li>
            Row-level security — your data is only accessible by your account
          </li>
          <li>Regular backups</li>
        </ul>
        <p>
          Authentication is handled by Supabase Auth, which supports OAuth
          providers (Google, Apple) and secure email/password sign in.
        </p>
      </section>

      <section id="sharing">
        <h2><span class="section-num">4</span> Information Sharing</h2>
        <p>
          We do <strong>not</strong> sell, rent, or trade your personal
          information. We may share limited data only in these situations:
        </p>
        <ul>
          <li>
            <strong>Service providers:</strong> Supabase (database), Anthropic
            (AI features), and PostHog (product analytics) — only to the extent
            needed to operate and improve the service
          </li>
          <li>
            <strong>Legal requirements:</strong> If required by law or valid
            legal process
          </li>
          <li>
            <strong>Business transfer:</strong> In the event of a merger or
            acquisition, your data would transfer with appropriate notice
          </li>
        </ul>
      </section>

      <section id="ai">
        <h2><span class="section-num">5</span> AI Features (Ellie Advisor)</h2>
        <p>
          ELDE includes an AI-powered advisor called Ellie, powered by
          Anthropic's Claude API. When you use Ellie:
        </p>
        <ul>
          <li>
            Your debt account data is sent to Anthropic's API to generate
            personalized advice
          </li>
          <li>
            Anthropic's
            <a
              href="https://www.anthropic.com/privacy"
              style="color: var(--blue)"
              >privacy policy</a
            >
            applies to data processed through their API
          </li>
          <li>
            We do not store your Ellie conversations beyond your current session
          </li>
          <li>You can choose not to use Ellie — it is an optional feature</li>
        </ul>
      </section>

      <section id="account-deletion">
        <h2><span class="section-num">6</span> Data Retention</h2>
        <p>
          We retain your data for as long as your account is active. If you
          delete your account:
        </p>
        <ul>
          <li>
            All your financial data is permanently deleted from our database
          </li>
          <li>Your authentication record is removed</li>
          <li>This action cannot be undone</li>
        </ul>
        <p>
          You can delete your account at any time from the app's settings menu.
        </p>
      </section>

      <section id="rights">
        <h2><span class="section-num">7</span> Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li><strong>Access</strong> — request a copy of your data</li>
          <li>
            <strong>Correction</strong> — update or correct your data (directly
            within the app)
          </li>
          <li>
            <strong>Deletion</strong> — delete your account and all data at any
            time
          </li>
          <li><strong>Portability</strong> — request an export of your data</li>
          <li><strong>Opt out</strong> — stop using the service at any time</li>
        </ul>
        <p>
          To exercise any of these rights, contact us at
          <a href="mailto:elde.support@gmail.com" style="color: var(--blue)">elde.support@gmail.com</a
          >.
        </p>
      </section>

      <section id="children">
        <h2><span class="section-num">8</span> Children's Privacy</h2>
        <p>
          ELDE is not directed at children under the age of 13. We do not
          knowingly collect personal information from children under 13. If you
          believe a child has provided us with personal information, please
          contact us and we will delete it promptly.
        </p>
      </section>

      <section id="changes">
        <h2><span class="section-num">9</span> Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify
          you of significant changes by email or through a notice in the app.
          Your continued use of ELDE after changes constitutes acceptance of the
          updated policy.
        </p>
      </section>

      <div class="contact-card" id="contact">
        <h2>
          <span
            class="section-num"
            style="background: var(--cyan); color: var(--navy)"
            >10</span
          >
          Contact Us
        </h2>
        <p>
          If you have questions about this Privacy Policy or how we handle your
          data, please reach out:
        </p>
        <p style="margin-top: 12px">
          <strong style="color: #fff">Email:</strong>
          <a href="mailto:elde.support@gmail.com" style="color: var(--cyan)">elde.support@gmail.com</a>
        </p>
        <p>We aim to respond to all inquiries within 2 business days.</p>
        <p style="margin-top: 12px">
          <strong style="color: #fff">Website:</strong>
          <a href="https://elde.ai">elde.ai</a>
        </p>
      </div>
    </div>

    <footer>
      <p>© ${new Date().getFullYear()} ELDE. All rights reserved.</p>
      <p style="margin-top: 6px">
        <a href="https://elde.ai" style="color: var(--blue); text-decoration: none">elde.ai</a>
      </p>
    </footer>
  </body>
</html>
`;

export default function Privacy() {
  const now = new Date();
  const date = now.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  const html = privacyHTML.replace("LAST_UPDATED_DATE", date);
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      style={{ all: "initial", display: "block" }}
    />
  );
}
